import React, { useEffect, useState } from "react";
import { Card, Spinner, Form } from "react-bootstrap";
import { useParams } from "react-router-dom";

import CustomPagination from "Common/customPagination";
import { authServices } from "Utils/auth/services";
import PlUserBetEaventPlTable from "Common/Tables/eventPlTables/plUserBet";

interface UserSettledBetPayload {
    match_id: string;
    page: number;
    limit: number;
    search: {
      market_id: string;
      user_id: string;
    };
}

const PlUserBetEventPl: React.FC = () => {
  const { matchId, fancyId, userId } = useParams<any>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [casinoBetsData, setCasinoBetsData] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [itemsPerPage, setItemsPerPage] = useState<number>(50);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const getEventPlData = async (page: number = 1) => {
    if (!matchId) return;

    setIsLoading(true);
    try {
      const payload: UserSettledBetPayload = {
        match_id: matchId, // You might want to replace this with dynamic `matchId`
        page: currentPage, // Use currentPage
        limit: itemsPerPage, // Use itemsPerPage
        search: {
          market_id: fancyId ||"0", // Use dynamic `fancyId`
          user_id: userId || "0", // Use dynamic `user_id`
        },
      };

      const { response } = await authServices.getsetteledBet(payload);
      const metadata = response?.metadata;

      if (response?.data) {
        setCasinoBetsData(response.data?.data);
        setTotalItems(metadata?.[0]?.total || 0);
      } else {
        setCasinoBetsData([]);
        setTotalItems(0);
      }
    } catch (error) {
      console.error("Error fetching userwise PL data:", error);
      setCasinoBetsData([]);
      setTotalItems(0);
    } finally {
      setIsLoading(false);
    }
  };

  // Handle page change
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  // Handle items per page change
  const handleItemsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newItemsPerPage = Number(event.target.value);
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1); // reset to first page when limit changes
  };

  // Handle search input change
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
  };

  // Filter data based on search term
  const filteredData = searchTerm
    ? casinoBetsData.filter((item) =>
        item.match_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.sport_name.replace(/\(\d+\)/, '')?.toLowerCase().includes(searchTerm.toLowerCase())
     // Filtering by user_name
      )
    : casinoBetsData;

  // Fetch data when page or itemsPerPage changes
  useEffect(() => {
    getEventPlData(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, itemsPerPage, matchId, fancyId, userId]);

  // Handle row click event (e.g., navigating or opening a modal)
  const handleRowClick = (marketid: String, matchname: String) => {
    // Implement navigation or modal as needed
  };

  return (
    <div className="event-pl">
      <Card>
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <div className="d-flex gap-2 align-items-center">
              Show
              <select
                className="form-select w-auto"
                value={itemsPerPage}
                onChange={handleItemsPerPageChange}
              >
                <option value={50}>50</option>
                <option value={100}>100</option>
                <option value={150}>150</option>
                <option value={200}>200</option>
              </select>
              Entries
            </div>

            <Form.Control
              type="text"
              placeholder="Search user..."
              value={searchTerm}
              onChange={handleSearchChange}
              className="w-25"
            />
          </div>

          {isLoading ? (
            <div className="text-center">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          ) : (
            <>
              <PlUserBetEaventPlTable
                fancyPLData={filteredData} // Pass filtered data
                onClickRow={handleRowClick}
              />
              <CustomPagination
                currentPage={currentPage}
                totalItems={totalItems}
                itemsPerPage={itemsPerPage}
                onPageChange={handlePageChange}
              />
            </>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default PlUserBetEventPl;
